(($) => {

    var epaasADW = {


		/**
		 * Konfiguration des Tenants für diese Seite und URL des zentralen Scripts.
		 * Daten für den Tenant werden zentralseitig zur Verfügung gestellt.
		 */
		initData: {
			tenant: 'alphera_at',
			locale: 'de_AT'
		},

		// Sollte eigentlich nicht geändert werden müssen.
		epaasScriptSrc: "https://www.bmw.com/etc/clientlibs/wcmp/consentcontroller.fallback/epaas.js",





		bootstrap: function() {

			/**
			 * Wir setzen die Eventlisterner, bevor wir ePaas initialisieren, 
			 * damit wir sie jedenfalls ausgeführt werden.
			 */

			epaasADW.setEventListener();
			epaasADW.init();

		},


		/**
		 * Ladet das zentrale ePaas-Script von BMW und initialisiert es mit den Daten des beim ePaas-Team angelegten Tenant
		 */
		init: function() {

			$.getScript(epaasADW.epaasScriptSrc, function( data, textStatus, jqxhr ) {

				if( jqxhr.status === 200 ) {
					epaas.api.initialize(epaasADW.initData);
				}


			} );

		},


		setEventListener: function() {

			// register for 'initialized' event inside the client application
			(window.consentcontroller || window).addEventListener('consentcontroller.api.initialized', function( event ) {

				if (event.detail) {

					/**
					 * Ab hier können wir die Usages abfragen
					 */

					if(consentcontroller.api.isUsageAllowed("Matomo") ) {
						epaasADW.loadMatomo();
					}

				} else {
					console.log('ERROR: consent controller initialization failed', event);
				}

			} );

		},





		loadMatomo: function() {

            var _paq = window._paq = window._paq || [];
            /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
            _paq.push(['disableCookies']);
            _paq.push(['trackPageView']);
            _paq.push(['enableLinkTracking']);
            (function() {
                var u="https://tracking.bmw.at/";
                _paq.push(['setTrackerUrl', u+'matomo.php']);
                _paq.push(['setSiteId', '718']);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
            })();
		}

	};

	epaasADW.bootstrap();

})(jQuery);
